import forgotPassword from '../../../forgotPwd/forgotPassword.vue';
export default [{
    path: '/forgotPassword', //忘记密码
    component: forgotPassword
}];
